import '../style.scss';
import { InputTemplate } from 'views/templates/module/inputTemplate';
import { FormContentHeader, FormType } from 'views/templates/module/contentHeader';
import { useFatca } from './hooks';
import { MultiSelections } from 'views/mutual/inputRadio';
import { TemplateProps } from '../common';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { FatcaStatus } from 'views/utils/enums';

export type FatcaProps = {
  formik?: any;
  fatcaProps: any;
};

export const CorporateFatcaWrapper = () => {
  return <CorporateFatca {...useFatca({ isUpdate: false })} />;
};

export const CorporateFatca = ({
  formik,
  fatcaProps,
  isUpdate,
}: FatcaProps & TemplateProps) => {
  useCustomLocationName('口座開設申込みフォーム');

  return (
    <form onSubmit={formik!.handleSubmit} className="accountOpenTemplate">
      <div className="accountOpenTemplate_input">
        <FormContentHeader label="米国納税義務（FATCA）に関する確認" formType={FormType.Optional} />
        <CorporateFatcaBase fatcaProps={fatcaProps}/>
      </div>      
    </form>
  );
};

export const CorporateFatcaBase = ({fatcaProps}: FatcaProps) => {
  return (
    <div className="accountOpenTemplate_input_check">
       <div className="accountOpenTemplate_explanation">
        {'FATCAとは、米国納税義務者が、米国以外の金融機関の口座を利用し米国の納税を逃れることを防止するために制定されたものです。'}
        </div> 
          <MultiSelections
            items={[
              { label: '当社は日本企業です', value: FatcaStatus.JapaneseCompany},
              { label: '当社は米国法人または米国人所有外国事業体（※）です', value: FatcaStatus.UsCompany},
            ]}
            name="FatcaCorporate"
            {...fatcaProps}
          />
          <div className="accountOpenTemplate_explanation">
            <div>{'（※）実質的支配者の中に直接または間接的に25％を超える議決権または価値を有する米国人が一名以上いる外国事業体'}</div>
            <br/>
            <div>{'・上記内容について正確であることを、信託の受託者である株式会社ＦＰＧ信託（以下「ＦＰＧ信託」）宛てに宣誓します。'}</div>
            <div>{'・上記記載内容に変更があった場合には、ＦＰＧ信託宛てに30日以内に連絡いたします。'}</div>
            <div>{'・上記記載内容その他の情報から、ＦＰＧ信託において当社が「米国法人」または「受動的ＮＦＦＥ」等に該当する可能性があると判断した場合、ＦＰＧ信託宛てに別途所定の書式を提出いたします。同時にＦＰＧ信託が必要と判断した場合には契約内容および米国納税者番号等についてＦＰＧ信託が米国歳入庁(IRS)に定期的に報告することに同意します。'}</div>
          </div> 
        </div>
  );
}
